<template>
  <div class="reading">
    <Card :bordered="false" class="reading-card" v-if="data[page - 1]">
      <template
        v-if="
          data[page - 1].originalList && data[page - 1].originalList.length > 0
        "
      >
        <pre class="pre-text" v-for="item in data[page - 1].originalList">{{
          item.original
        }}</pre>
      </template>
      <pre v-else class="pre-text">
          {{ data[page - 1].article }}
        </pre
      >
    </Card>
    <Card :bordered="false" class="reading-card reading-question">
      <Row style="padding:20px" v-for="(item, index) in question" :key="index">
        <i-col span="22">
          <Card :bordered="false">
            <Card dis-hover>
              <p
                slot="title"
                v-html="item.describe"
                style="height: auto;font-weight: normal;"
              ></p>
              <p
                slot="title"
                v-for="(m, mindex) in item.matchValue"
                :key="mindex"
                style="height: auto;font-weight: normal;"
              >
                {{ m }}
              </p>
              <div class="img">
                <img
                  :src="item.imageUrl"
                  style=""
                  v-if="item.imageUrl"
                  @click="viewImg"
                />
              </div>
              <ul>
                <li
                  v-if="
                    !(
                      item.questionsType.includes('填词摘要') ||
                      item.questionsType.includes('段落填空配对题')
                    )
                  "
                  ref="list"
                  :id="'element' + item1.serial"
                  v-for="(item1, index1) in item.trunkList"
                  :key="index1"
                  class="question-item"
                  @click=""
                  style="display: flex;"
                  :style="{
                    flexDirection: item1.content.includes('[blank]')
                      ? 'row'
                      : 'column',
                    alignItems: item1.content.includes('[blank]')
                      ? 'center'
                      : ''
                  }"
                >
                  <p
                    v-html="contentFilters(item1.content)"
                    style="padding: 10px 0"
                  ></p>
                  <i-input
                    v-if="item1.content.includes('[blank]')"
                    v-model="value[item1.serial - 1]"
                    :placeholder="item1.serial"
                    style="width: 150px;margin-left: 30px;display: flex;align-items: center;"
                    @on-blur="inputBlue(item1.serial)"
                  ></i-input>
                  <p
                    style="padding-left: 20px;color:#f00"
                    v-if="isShowAnswer"
                    :style="
                      colorCom(
                        item1.answer,
                        value[item1.serial - 1],
                        checkboxItem[item1.id]
                      )
                    "
                  >
                    {{ answerCom(item1.answer) }}
                  </p>
                  <!--判断题-->
                  <ul v-if="item.questionsType === '判断题'">
                    <li class="question-item select" style="background: #eee">
                      <Radio-group vertical v-model="value[item1.serial - 1]">
                        <Radio label="TRUE"><span>TRUE</span></Radio>
                        <Radio label="FALSE"><span>FALSE</span></Radio>
                        <Radio label="NOT GIVEN"><span>NOT GIVEN</span></Radio>
                      </Radio-group>
                    </li>
                  </ul>
                  <!--选择题-->
                  <ul v-if="item1.option && item1.answer.length === 1">
                    <li class="question-item select" style="background: #eee">
                      <Radio-group vertical v-model="value[item1.serial - 1]">
                        <Radio
                          v-for="(item3, index3) in item1.option"
                          :key="index3"
                          :label="index3"
                        >
                          <span v-html="item3"></span>
                        </Radio>
                      </Radio-group>
                    </li>
                  </ul>
                  <!--多选题-->
                  <ul v-if="item1.option && item1.answer.length > 1">
                    <li class="question-item select" style="background: #eee">
                      <Checkbox-group
                        @on-change="checkboxChange"
                        class="checkbox"
                        v-model="checkboxItem[item1.id]"
                      >
                        <span
                          @click="showLength(item1.serial, item1.id)"
                          style="display: flex;flex-direction: column;"
                        >
                          <Checkbox
                            v-for="(item3, index3) in item1.option"
                            :key="index3"
                            :label="index3"
                            :disabled="
                              checkboxItem[item1.id] !== undefined &&
                                isLen[item1.id] &&
                                !checkboxItem[item1.id].includes(index3)
                            "
                          >
                            <span
                              v-html="item3"
                              style="padding-left: 5px"
                            ></span>
                          </Checkbox>
                        </span>
                      </Checkbox-group>
                    </li>
                  </ul>
                </li>
                <li
                  v-if="
                    item.questionsType.includes('填词摘要') ||
                      item.questionsType.includes('段落填空配对题')
                  "
                  ref="list"
                  class="question-item"
                >
                  <p v-html="blankFilters(item.tableValue)"></p>
                  <ul>
                    <li
                      v-for="(item1, index1) in item.trunkList"
                      :key="index1"
                      style="margin-top: 20px;display: flex;align-items: center;"
                      :id="'element' + item1.serial"
                    >
                      <!--<p>1</p>-->
                      <i-input
                        v-model="value[item1.serial - 1]"
                        :placeholder="item1.serial"
                        style="width: 150px;display: flex;align-items: center;"
                        @on-blur="inputBlue(item1.serial)"
                      >
                      </i-input>
                      <p
                        style="padding-left: 20px;color: #333"
                        v-if="isShowAnswer"
                        :style="colorCom(item1.answer, value[item1.serial - 1])"
                      >
                        {{ answerCom(item1.answer) }}
                      </p>
                    </li>
                  </ul>
                </li>
              </ul>
            </Card>
            <p slot="title" v-html="item.theme"></p>
          </Card>
        </i-col>
      </Row>
    </Card>
  </div>
</template>

<script>
export default {
  name: "Reading",
  props: {
    data: Array,
    question: Array,
    contentFilters: Function,
    page: Number,
    isPhone: Boolean,
    value: Array,
    inputBlue: Function,
    checkboxChange: Function,
    checkboxItem: Array,
    isLen: Array,
    showLength: Function
  },
  data() {
    return {
      isShowAnswer: false
    };
  },
  computed: {
    colorCom() {
      return function(l, r, id) {
        let arr = [];
        l.forEach(item => {
          arr += ` ${item}`;
        });
        //输入的内容 r
        //正确答案 l
        // console.log(l);
        if (Number.isFinite(r)) {
          switch (r) {
            case 0:
              r = "A";
              break;
            case 1:
              r = "B";
              break;
            case 2:
              r = "C";
              break;
            case 3:
              r = "D";
              break;
          }
          if (arr.trim() === r.trim()) {
            return {
              color: "#60b534"
            };
          } else {
            return {
              color: "#f00"
            };
          }
        } else if (l.length > 1) {
          let arrs = [];
          if (id) {
            id.forEach(item => {
              switch (item) {
                case 0:
                  arrs.push("A");
                  break;
                case 1:
                  arrs.push("B");
                  break;
                case 2:
                  arrs.push("C");
                  break;
                case 3:
                  arrs.push("D");
                  break;
                case 4:
                  arrs.push("E");
                  break;
                case 5:
                  arrs.push("F");
                  break;
                case 6:
                  arrs.push("G");
                  break;
                case 7:
                  arrs.push("H");
                  break;
              }
            });
          }
          // arrs = JSON.parse(JSON.stringify(arrs)
          console.log(l.toString());
          console.log(arrs.toString());
          if (l.toString() === arrs.toString()) {
            return {
              color: "#60b534"
            };
          } else {
            return {
              color: "#f00"
            };
          }
        } else {
          let newL = arr.toLowerCase().trim();
          if (r) {
            let newR = r.toLowerCase().trim();
            if (newL === newR) {
              return {
                color: "#60b534"
              };
            } else {
              return {
                color: "#f00"
              };
            }
          }
        }
      };
    },
    answerCom() {
      return function(list) {
        let arr = [];
        list.forEach(item => {
          arr += ` ${item}`;
        });
        return `正确答案：${arr}`;
      };
    }
  },
  methods: {
    viewImg(event) {
      const imgNode = event.currentTarget;
      if (!imgNode.viewer) {
        $(imgNode).viewer();
        imgNode.click();
      } else {
        $(imgNode).viewer();
      }
    },
    blankFilters(val, num) {
      let newVal = val.split("[blank][/blank]"); //字符串全部切割
      newVal = newVal.join("__________");
      return newVal;
    },
    seeAnswer() {
      this.isShowAnswer = !this.isShowAnswer;
    }
  }
};
</script>

<style scoped lang="stylus">
.ivu-card-head p{
  overflow visible!important;
  white-space normal!important;
}
.ivu-col-span-22
  width 100%
.question-item
  padding 10px 10px
.checkbox
  display: flex
  flex-direction: column
  .ivu-checkbox-wrapper
    padding:10px 0
.checkbox
  display: flex
  flex-direction: column
  .ivu-checkbox-wrapper
    padding:10px 0
.reading
  display: flex
  justify-content: space-between
.reading-card
  width: 50%;
  margin: 20px;
  overflow-y: scroll;
  height: 760px;
.reading-p
  float: left
  font-size:14px
  padding-bottom: 10px
  text-indent: 2em;
  white-space: pre-line;

.writing
  display: flex
  justify-content: space-between

.pre-text
  white-space:pre-wrap
/*.ivu-row:last-child*/
  /*margin-bottom  67px*/
</style>



// WEBPACK FOOTER //
// src/pages/Exercise/children/Reading.vue